import { router } from 'expo-router';
import { useCallback, useMemo } from 'react';
import { FlatList, ListRenderItemInfo, View } from 'react-native';

import { ILoyaltyQuestUi } from '@fhs-legacy/frontend/src/generated/graphql-gateway';
import { ClickEventComponentNames, EventTypes } from '@fhs-legacy/frontend/src/state/crm-events';
import { CustomEventNames } from '@fhs-legacy/frontend/src/state/crm-events';
import { useCRMEventsContext } from '@fhs-legacy/frontend/src/state/crm-events';

import { ChallengeClickEventLabels } from '../../analytics';
import { ChallengeCard, ChallengeCardProps, ChallengeCardSkeleton } from '../../components';
import { useChallengesWithProgressUi } from '../../state/challenges-ui-helper-state';
import { getChallengeBadge } from '../../utils';
import { getChallengeDescription } from '../../utils';

const renderChallengeCard = ({ item }: ListRenderItemInfo<ChallengeCardProps>) => (
  <ChallengeCard {...item} />
);

const renderItemSeparator = () => <View style={{ height: 16 }} />;

export function Challenges({ isLoading }: { isLoading: boolean }) {
  const { data } = useChallengesWithProgressUi();
  const { logRBIEvent } = useCRMEventsContext();

  const showInfo = useCallback(
    (challenge: ILoyaltyQuestUi) => {
      router.navigate('challenge' + `/${challenge.id}`);
      logRBIEvent({
        name: CustomEventNames.CLICK_EVENT,
        type: EventTypes.Other,
        attributes: {
          component: ClickEventComponentNames.BUTTON,
          text: ChallengeClickEventLabels.OPEN_INFO,
          headerText: challenge.name ?? undefined,
        },
      });
    },
    [logRBIEvent]
  );

  const challengesCardProps = useMemo(
    () =>
      data?.map<ChallengeCardProps>(challenge => ({
        image: challenge.image,
        title: challenge.name ?? '',
        description: getChallengeDescription(challenge),
        onPress: () => showInfo(challenge),
        buttonText: 'See Challenge',
        badge: getChallengeBadge(challenge.status, challenge.progress),
        onPressInfo: () => showInfo(challenge),
      })) ?? [],
    [data, showInfo]
  );

  if (isLoading) {
    return <ChallengeCardSkeleton style={{ alignSelf: 'center', marginTop: 16 }} />;
  }

  return (
    <FlatList
      style={{ marginTop: 16, alignSelf: 'center' }}
      data={challengesCardProps}
      renderItem={renderChallengeCard}
      ItemSeparatorComponent={renderItemSeparator}
    />
  );
}
